import { render, staticRenderFns } from "./BadgeState.vue?vue&type=template&id=2e0a9142&scoped=true&"
import script from "./BadgeState.vue?vue&type=script&lang=ts&"
export * from "./BadgeState.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeState.vue?vue&type=style&index=0&id=2e0a9142&lang=scss&scoped=true&"
import style1 from "./BadgeState.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a9142",
  null
  
)

export default component.exports